module.exports = __webpack_public_path__ + "img/bg-bean-01.d777eec6.png";